<template>
  <v-touch class="day-cal__overlay">
    <div class="days-container" :style="{height: height + 'px'}">
      <full-calendar
        :caldate="date"
        :events="lessons"
        :viewState="viewState"
        :locale="locale"
        :i18n="i18n"
        @eventclick="onTap">
      </full-calendar>
      <!-- Weekplan -->
      <div class="pad-10 weekplan-header marg-20-top">
        <span class="date">{{calRangeView}}</span>
        <h2>{{ $t('calendars.week_plan_and_note.week_plan')}}</h2>
      </div>
      <weekplan class="pad-10"
                :weeknote="weeknote"
                :calId="calId"
                :date="date"
                :events="lessons">
      </weekplan>
    </div>
  </v-touch>
</template>

<script>
  import fullCalendar from '../../../calendar/FullCal.vue'
  import weekplan from '../WeekPlan/WeekPlan.vue'
  import moment from 'moment'

  export default{
    props: ['lessons', 'date', 'dateChange', 'viewState', 'calId', 'weeknote', 'locale', 'i18n'],
    components: {fullCalendar, weekplan},
    computed: {
      calRangeView () {
        let s = moment(this.date).isoWeekday(1)
        let e = moment(this.date).isoWeekday(7)
        let start = s.format('DD.')
        let start2 = s.format('DD. MMM')
        let end = e.format('DD. MMM YYYY')
        // If same month
        if (s.format('MM') === e.format('MM')) {
          return start + ' - ' + end
        } else {
          return start2 + ' - ' + end
        }
      }
    },
    data () {
      return {
        height: 300
      }
    },
    methods: {
      onTap (lesson) {
        this.$emit('eventClicked', lesson)
      },
      calculateHeightForCalendar () {
        let windowHeight = window.innerHeight
        this.height = windowHeight - 55 - 55
      },
      setScrollTop (val) {
        this.$el.scrollTop = val.top - 20
      }
    },
    mounted () {
      window.addEventListener('resize', () => {
        this.calculateHeightForCalendar()
      })
      this.calculateHeightForCalendar()
    }
  }
</script>

<style scoped>
  .day-cal__overlay {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .days-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 250px;
    width: 600px;
  }

</style>



// WEBPACK FOOTER //
// CalContainer.vue?6876ed46